export default {
    name: 'Spinner',
    props: {
        heightClass: {
            type: String,
            default: 't-50 ht-150'
        },
    }
};